import { useState, useEffect } from "react";
import { API } from "@/App";

let _cache = null;
let _promise = null;

export function useCourseData() {
  const [data, setData] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) {
      setData(_cache);
      setLoading(false);
      return;
    }
    if (!_promise) {
      _promise = fetch(`${API}/courses/all-data`, { credentials: "include" })
        .then(r => r.ok ? r.json() : null)
        .then(d => { _cache = d; return d; })
        .catch(() => null);
    }
    _promise.then(d => {
      if (d) setData(d);
      setLoading(false);
    });
  }, []);

  return { coursesData: data, coursesLoading: loading };
}
